import React, { memo, useContext } from 'react';

import Button from 'b2b-ui-components-lib/lib/components/button';

import { AppContext } from 'App';

import blobImage from 'assests/svg/DI-blob.svg';

import './Banner.scss';

const Banner = ({ defaultConfig = false, showBtn = true, onBtnClick = (e) => {} }) => {
  const { pageData } = useContext(AppContext);
  const { title, subTitle, default_statistics, landing_statistics, btnName, imageUrl } = pageData?.banner;

  const renderStatsSection = () => {
    const statsData = defaultConfig ? default_statistics : landing_statistics;

    return statsData?.map((value, index) => (
      <li key={index}>
        {value.title}
        <span className="sub_text">{value.subTitle}</span>
      </li>
    ));
  };

  return (
    <div className="banner_section">
      <div className="container">
        <div className="banner_wrapper">
          <div className="content_intro">
            <h1 className="intro_head">{title}</h1>
            <h4>{subTitle}</h4>
            <div className="statistics">
              <ul className="stats_list">{renderStatsSection()}</ul>
            </div>
            {showBtn && <Button displayName={btnName} onClick={onBtnClick} />}
          </div>
          <div className="blob_image">
            <img src={imageUrl || blobImage} alt="Internet Leased Line" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(Banner);
